import React from "react"
import {FieldGlistViewProps} from "../../../render/glist/glist-view";
import FieldViewSmall from "../../../render/view-small";

export default function FieldProto_GListView(props:FieldGlistViewProps) {

    // now default = viewSmall

    return <FieldViewSmall {...props} />

}
